__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.10.1-76d02d2-18298/_next/";